import { API_BASE_URL } from '../config/api';

interface CacheItem {
  data: any;
  timestamp: number;
}

const cache = new Map<string, CacheItem>();
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour

export const fetchWithCache = async (url: string) => {
  // Normalize URL if relative
  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
  
  const cached = cache.get(fullUrl);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }

  try {
    const response = await fetch(fullUrl);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to fetch from ${fullUrl}: ${response.statusText}`);
    }
    
    const data = await response.json();
    cache.set(fullUrl, { data, timestamp: Date.now() });
    return data;
  } catch (error) {
    console.error(`API Fetch Error (${fullUrl}):`, error);
    throw error;
  }
};

